import { createStyles } from '@material-ui/core';

const styles = createStyles({
  grid: {
    background: '#CCCCCC',
    display: 'grid',
    gridTemplateColumns: '40px 1fr 40px',
    gridTemplateRows: '1fr 25px',
    justifyItems: 'center',
    maxWidth: '350px',

    '@media (min-width: 768px)': {
      gridTemplateRows: '25px 1fr'
    }
  },

  text: {
    gridColumn: '1 / 4',
    gridRow: '1 / 2',
    margin: '1em',
    textAlign: 'center',

    '@media (min-width: 768px)': {
      gridRow: '2 / 3'
    }
  },

  downArrow: {
    gridColumn: '2 / 3',
    gridRow: '2 / 3',

    '@media (min-width: 768px)': {
      display: 'none'
    }
  },

  upArrow: {
    gridColumn: '2 / 3',
    gridRow: '1 / 2',
    paddingLeft: '120px',

    '@media (max-width: 767px)': {
      display: 'none'
    }
  },

  close: {
    gridColumn: '3 / 4',
    gridRow: '2 / 3',

    '@media (min-width: 768px)': {
      gridRow: '1 / 2'
    }
  }
});

export default styles;
